import * as React from "react";
import { IOWidget, mk_widget, option, Options } from "../widget";

export interface TextAreaOptions extends Options { rows?:number, columns?:number }

interface TextAreaProps {
  options?:TextAreaOptions
  input:string,
  on_done:(output:string) => void
}

interface TextAreaState { }

class TextArea extends React.Component<TextAreaProps, TextAreaState> {
  constructor(props:TextAreaProps, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <textarea id={option("id", this.props.options)}
      key={option("key", this.props.options)}
      rows={option("rows", this.props.options)}
      cols={option("columns", this.props.options)}
      value={this.props.input}
      onChange={e => this.props.on_done(e.currentTarget.value)} />
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const text_area = (options?:TextAreaOptions) : IOWidget<string, string> => (input:string) =>
  mk_widget({
    run:(on_done:(output:string) => void) =>
      React.createElement<TextAreaProps>(TextArea, { on_done, input, options })
  })



// WEBPACK FOOTER //
// ./node_modules/widgets-for-react/src/primitives/text_area.tsx